export const FooterLink2 = [
  {
    title: "Subjects",
    links: [
      { title: "Al", link: "/al" },
      { title: "Data Science", link: "/data-science" },
      { title: "Discreate Mathematics", link: "/discreate-mathematics" },
      { title: "Probability", link: "/probability" },
      { title: "Linear Algebra", link: "/linear-algebra" },
      { title: "Calculus", link: "/calculus" },
      { title: "Digital logic", link: "/digital-logic" },
      { title: "Data Structure", link: "/data-structure" },
      { title: "Algorithm", link: "/algorithm" },
      { title: "Compiler Design", link: "/compiler-design" },
      { title: "Operating System", link: "/operating-system" },
      { title: "DBMS", link: "/dbms" },
      { title: "Machine Learning", link: "/machine-learning" },
      { title: "Theory of Computaion", link: "/toc" },
      { title: "Computer Network", link: "/computer-network" },
      { title: "Computer Organization", link: "/coa" },
      { title: "Machine Learning", link: "/machine-learning" },
    ],
  },
  {
    title: "Languages",
    links: [
      { title: "C Programmming", link: "/c-programming" },
      { title: "Python", link: "/python" },
      { title: "SQL", link: "/sql" },
      
    ],
  },
  {
    title: "Learning Path",
    links: [
        {title: "Paper Analysis", link: "/paper-analysis"},
        {title: "Structured Path", link: "/structured-path"},
        {title: "Full Catalog", link: "/full-catalog"},
        {title: "Beta Content", link: "/beta-content"}
    ]
  }
];
